import { ThemeSwitcherContext } from "context/ThemeSwitcherContextProvider";
import { useContext } from "react";

function useChangeTheme() {
  const { theme, setTheme } = useContext(ThemeSwitcherContext);

  return { setTheme, theme };
}

export default useChangeTheme;
